import { render, staticRenderFns } from "./ReportsView.vue?vue&type=template&id=40e299b2&scoped=true&lang=pug&"
import script from "./ReportsView.vue?vue&type=script&lang=js&"
export * from "./ReportsView.vue?vue&type=script&lang=js&"
import style0 from "./ReportsView.vue?vue&type=style&index=0&id=40e299b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e299b2",
  null
  
)

export default component.exports